export const SET_DATALAYER_EMAIL_MOBILE = 'SET_DATALAYER_EMAIL_MOBILE';
export const RESET_DATALAYER_EMAIL_MOBILE = 'RESET_DATALAYER_EMAIL_MOBILE';
